import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { StakingcompletePage } from '../stakingcomplete/stakingcomplete';

/**
 * Generated class for the StakingconfirmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-stakingconfirm',
  templateUrl: 'stakingconfirm.html',
})
export class StakingconfirmPage {

    loginId: string;
	api_key: string;
	version: string;
	email: string;

	value: string;
	month: string;
	day: string;
	min: string;
	rate: string;
	date: string;
	start: string;
	end: string;
	idx: string;
    
    coin_unit: string;
    unit: string;
    
    texts: any = [];
	language : string;
	imagePath:string;

    isSend : boolean = true;

    constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
        public viewCtrl: ViewController,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		public app: App
    ) {
        this.value = this.navParams.get("value");
	}

    ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "stakingconfirm");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.email = localStorage.getItem("email");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");

        this._get_texts();

        this._init();
        
    }

    _get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).stakingconfirm;
	}

    _init() {
        //// 서버로부터의 데이타
        let url = "staking/base/index/confirm";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            value: this.value,
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                this.value = res.value;
                this.month = res.month;
                this.day = res.day;
                this.min = res.min;
                this.rate = res.rate;
                this.date = res.date;
                this.start = res.start;
                this.end = res.end;
                this.idx = res.idx;

            } else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.navCtrl.pop();

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                this.navCtrl.pop();
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
            
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
    }

    _apply() {
        this.isSend = false;
        // this.viewCtrl.dismiss({date: this.date, start: this.start, end: this.end, value: this.value, idx: this.idx});
        
        let url = "staking/base/index/save";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            date: this.date,
            start: this.start,
            end: this.end,
            value: this.value,
            idx: this.idx,
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                this.isSend = true;
                let modal = this.modalCtrl.create(StakingcompletePage, {value: this.value});
                modal.present();
                this.viewCtrl.dismiss("ok");

            } else if(res.result ==="DONOT"){
                this.isSend = true;
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.viewCtrl.dismiss();

            } else if(res.result ==="LOGOUT"){
                this.isSend = true;
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                this.isSend = true;
                this.viewCtrl.dismiss();
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
            
        },(err)=>{	
            //// HTTP 에러인 경우
            this.isSend = true;
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
    }

    _cancel() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/stakingconfirm/stakingconfirm.ts